export default "__VITE_ASSET__4cff3cfd__"